const initialState = {
    location: {},
    updating: false,
    updated: false,
    error: null
}

export function locationReducer(state = initialState, action) {

    switch (action.type) {

        case "CREATE_LOCATION":
        case "FETCH_LOCATION":
        case "UPDATE_LOCATION": {
            return { ...state, updating: true, updated: false, error: null }
        }

        case "CREATE_LOCATION_REJECTED":
        case "FETCH_LOCATION_REJECTED":
        case "UPDATE_LOCATION_REJECTED": {
            return { ...state, updating: false, error: action.payload }
        }

        case "CREATE_LOCATION_FULFILLED":
        case "FETCH_LOCATION_FULFILLED":
        case "UPDATE_LOCATION_FULFILLED": {
            return { ...state, updating: false, updated: true, location: action.payload.data }
        }

        case "LOCATION_ERROR": {
            return { ...state, error: null }
        }

        default:
            return state
    }
}